// src/hooks/useApi.js - VERSÃO FINAL

import { useState, useEffect, useCallback } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3057/api';

// Dados mockados - apenas um sensor na localização especificada
const MOCK_SENSOR = {
  id: 'sensor-mock-001',
  device_id: 'sensor-mock-001',
  latitude: -15.792926726089211,
  longitude: -47.89306978980245,
  lat: -15.792926726089211,
  lng: -47.89306978980245,
  city: 'Brasília',
  country: 'Brazil',
  type: 'indoor',
  quality: 85.5,
  temperature: 22.3,
  humidity: 45.2,
  co2: 420,
  pm25: 12.5,
  pm10: 18.3,
  aqi: 45,
  pmv: -0.2,
  status: 'online',
  hasData: true,
  is_anonymous: false,
  business_name: 'Evolve Brasília',
  location_name: 'Evolve Brasília',
  walletAddress: '0xA1B2C3D4E5F6G7H8I9J0K1L2M3N4O5P6Q7R8S9T0',
  earnings: 1250,
  // TEMPORÁRIO: Fixar em 15 minutos atrás para apresentação
  lastUpdate: new Date(Date.now() - 15 * 60 * 1000).toISOString()
};

export const useApi = () => {
  const [sensors, setSensors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSensors = useCallback(async (layer = 'indoor') => {
    setLoading(true);
    setError(null);
    
    try {
      console.log(`🔄 Buscando sensores da API - tipo: ${layer}`);
      
      // Buscar dados reais da API
      const response = await fetch(`${API_BASE_URL}/sensors?type=${layer}`);
      
      if (!response.ok) {
        throw new Error(`Erro na API: ${response.status}`);
      }
      
      const result = await response.json();
      
      if (result.success && result.data) {
        console.log(`✅ ${result.data.length} sensores carregados`);
        setSensors(result.data);
      } else {
        // Fallback para mock se API não retornar dados válidos
        console.warn('⚠️ API não retornou dados válidos, usando mock');
        let filteredSensor = { ...MOCK_SENSOR };
        
        if (layer === 'airQuality') {
          filteredSensor = {
            ...filteredSensor,
            pm25: 12.5,
            pm10: 18.3,
            aqi: 45
          };
        }
        
        setSensors([filteredSensor]);
      }
      
    } catch (err) {
      console.error('❌ Erro ao buscar sensores:', err);
      console.log('⚠️ Usando dados mock como fallback');
      
      // Fallback para mock em caso de erro
      let filteredSensor = { ...MOCK_SENSOR };
      
      if (layer === 'airQuality') {
        filteredSensor = {
          ...filteredSensor,
          pm25: 12.5,
          pm10: 18.3,
          aqi: 45
        };
      }
      
      setError(err.message);
      setSensors([filteredSensor]);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    sensors,
    loading,
    error,
    fetchSensors,
    refetch: fetchSensors
  };
};
